import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import './App.css';
import BusDue from "./BusDue"
import MinoToggle from "./MinoToggle"

export default function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/mino">
            <MinoToggle />
          </Route>
          <Route path="/">
            <BusDue />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}



// WEBPACK FOOTER //
// ./src/App.js